import { buildApiUrl, Type, sendGetRequest } from '@/api/api'
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

export const providerSchema = z.array(z.object({
  Id: z.number(),
  RegionId: z.number(),
  Name: z.string(),
  Linked: z.number()
}))

export async function fetchProviders(regions?: number[]) {
  const query = Array.isArray(regions) && regions.length > 0
    ? '?' + regions.map(id => `provinceIds=${id}`).join('&')
    : '';

  const url = buildApiUrl(Type.Core, `tariffs/providers${query}`);
  const { data } = await sendGetRequest(url);
  return assertSchemaAndCoerce(data, providerSchema);
}


